import * as React from 'react';
import {FC} from 'react';
import {Tabs} from '../../lib/components/tabbar';
import {RoomList} from './RoomList';
import {UserList} from './UserList';
import {IRoom, IUser} from '../../Constants/Interfaces';
import {sortChatsArray} from '../../Chats/utils';
import {INotifications} from '../../Messages';
import {AddressList} from './AddressList';


interface IListProps {
    tab: Tabs;

    rooms: IRoom[];
    allUsers: IUser[];

    notifications: INotifications;

    buddyIds: string[];
    blockedIds: string[];
    addressIds: string[];

    selectedId: string;
    selectedRoom: string;
    myId: string;
}


export const List: FC<IListProps> = (props) => {
    switch (props.tab) {


        case Tabs.home:

            const userList = props
                .allUsers
                .filter((user) => user.uid !== props.myId)
                //Filter by selected room
                .filter((user) => props.selectedRoom === 'metaverse' || user.currentlyOn === props.selectedRoom)
                // guest/user
                .sort((a, b) => (a.name === 'guest' && b.name === 'Guest' ? 0 : b.name === 'Guest' ? -1 : 1))
                // buddy/not buddy
                .sort((a, b) => props.buddyIds.includes(a.uid) && props.buddyIds.includes(b.uid) ? 0 : props.buddyIds.includes(a.uid) ? -1 : 1)
                // online/offline
                .sort((a, b) => (a.online && b.online ? 0 : a.online ? -1 : 1));


            const usersInCurrentRoom = userList.filter((user) => user.currentlyOn === props.selectedRoom);

            const onlineUsersCount = (props.selectedRoom === 'metaverse' ? props.allUsers : usersInCurrentRoom)
                .filter((user) => user.uid !== props.myId && user.online).length;


            return <>
                <RoomList
                    notifications={props.notifications}
                    users={props.allUsers.filter((user) => user.uid !== props.myId)}
                    rooms={sortChatsArray(props.rooms)}
                    selectedId={props.selectedId}/>

                <UserList
                    notifications={props.notifications}
                    placeholder={`${onlineUsersCount} other users online`}
                    users={userList}
                    selectedId={props.selectedId}
                    myBlacklist={props.blockedIds}
                    myBuddies={props.buddyIds}
                    myId={props.myId}/>
            </>;


        case Tabs.buddies:
            const buddies = props.allUsers.filter((user) => props.buddyIds.includes(user.uid)).sort((a, b) => {
                return props.notifications[a.uid] - props.notifications[b.uid];
            });

            return <>
                <UserList
                    notifications={props.notifications}
                    placeholder={`Buddies`}
                    users={buddies}
                    selectedId={props.selectedId}
                    myBlacklist={props.blockedIds}
                    myBuddies={props.buddyIds}
                    myId={props.myId}
                />
                <AddressList
                    addresses={props.addressIds}
                    selectedId={props.selectedId}
                    users={props.allUsers}
                />
            </>;
    }
};